import { ScrollNavigationItem } from '@src/components/molecules/scroll-navigation';
import { TripPreviewCard as TripPreview } from '@src/components/organisms/trip-preview-card';
import { TripListItemProvider } from '@src/contexts/trip-list-item-context';
import { TripListItem } from '@src/types/api/models';

import styles from './trip-section.module.css';

type TripSectionProps = {
  title: string;
  slug: string;
  tabText: string;
  trips: TripListItem[];
};

export const TripSection = ({ title, slug, tabText, trips }: TripSectionProps) => (
  <ScrollNavigationItem id={slug} linkText={tabText}>
    <h4 className={styles.sectionHeading}>{title}</h4>

    <div className={styles.container}>
      {trips.map((trip) => (
        <TripListItemProvider value={{ trip }} key={trip.id}>
          <TripPreview />
        </TripListItemProvider>
      ))}
    </div>
  </ScrollNavigationItem>
);
